import React, {FC} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import Link from 'next/link';
import {showAuthDialog} from 'modules/auth/thunks';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import {useBannerClickGtag} from 'hooks/analytics/gtag/banners/useBannerClickGtag';
import {TRUST_SLIDER_DATA} from 'modules/slider/constants';

type TTrustItem = (typeof TRUST_SLIDER_DATA)[number];

type TProps = TTrustItem & {
    position: number;
    gtagEventsEnabled?: boolean;
};

export const TrustSliderItem: FC<TProps> = ({
    description,
    linkHref,
    linkText,
    needAuth,
    src,
    id,
    title,
    position,
    gtagEventsEnabled = true,
}) => {
    const dispatch = useAppDispatch();
    const isLoggedIn = useIsLoggedIn();

    const bannerClickGtag = useBannerClickGtag();

    const handleBannerClick = () => {
        bannerClickGtag({
            enabled: gtagEventsEnabled,
            type: 'common',
            creative: 'promo_page_trust',
            banner: {
                id,
                name: title,
                position,
            },
        });
    };

    const handleShowAuth = () => {
        dispatch(showAuthDialog);
        handleBannerClick();
    };

    return (
        <div className={style.main} onClick={needAuth && !isLoggedIn ? handleShowAuth : handleBannerClick}>
            <img alt={title} className={style.image} src={src} />
            <div className={style.info}>
                <Typography className={style.title} element={'h2'} variant={'ch-title-24-reg'}>
                    {title}
                </Typography>
                <Typography className={style.description} element={'p'} variant={'body-14-reg'}>
                    {description}
                </Typography>
                {needAuth && !isLoggedIn ? (
                    <button className={style.link}>
                        <Typography variant={'label-14-m'}>{linkText}</Typography>
                    </button>
                ) : (
                    <Link className={style.link} href={linkHref} target={'_blank'}>
                        <Typography variant={'label-14-m'}>{linkText}</Typography>
                    </Link>
                )}
            </div>
        </div>
    );
};
